<template>
  <ol class="space-y-1">
    <li
      v-for="transaction in transactions"
      :key="transaction.id"
    >
      <RouterLink
        :to="getTransactionDetailRoute(transaction)"
        class="flex w-full flex-row items-center justify-start space-x-2 rounded-lg bg-background px-3 py-1 shadow hover:bg-background-fg/3"
      >
        <div class="flex flex-col items-start">
          <span class="mr-1 text-xs text-background-fg/87">
            {{ formatToDate(transaction.createdAt) }}
          </span>
          <span class="text-sm font-semibold">
            {{ formatToTime(transaction.createdAt) }}
          </span>
        </div>

        <div class="flex-1">
          <p
            :class="[
              transaction.status === 'successful'
                ? {
                    payment: 'text-background-fg',
                    refund: 'text-error',
                    reversal: 'text-error',
                  }[transaction.type]
                : 'text-black/30',
              'line-clamp-1 text-right font-semibold',
            ]"
          >
            <span class="mr-2 text-sm">{{
              getStatusText(transaction)
            }}</span>

            <span
              v-if="
                transaction.transactionMethod ===
                  'pos_card' &&
                transaction.isDcc &&
                transaction.isDccFieldsPopulated
              "
              class="mr-2 text-xs"
              :class="
                transaction.status === 'successful'
                  ? {
                      payment: 'text-background-fg/70',
                      refund: 'text-error/70',
                      reversal: 'text-error',
                    }[transaction.type]
                  : 'text-background-fg/40'
              "
            >
              <template v-if="transaction.type === 'refund'"
                >-</template
              >
              {{
                formatToCurrencyString(
                  transaction.dccCardCurrencyAmount,
                  transaction.dccCardholderCurrency
                )
              }}
            </span>

            <template v-if="transaction.type === 'refund'"
              >-</template
            >
            {{
              formatToCurrencyString(
                transaction.amountTransactedTotal,
                transaction.currency
              )
            }}
          </p>
        </div>

        <div class="flex w-16 shrink-0 justify-center">
          <PaymentDetailChip :payment="transaction" />
        </div>
      </RouterLink>
    </li>
  </ol>
</template>

<script setup lang="ts">
import type { ListTransactionsResponseItem } from "@/services/transactions/listTransactions"
import type { RouteLocationRaw } from "vue-router"

const props = defineProps<{
  transactions: ListTransactionsResponseItem[]
}>()

const { formatToCurrencyString } = useCurrency()

const getTransactionDetailRoute = (
  transaction: ListTransactionsResponseItem
): RouteLocationRaw =>
  transaction.orderId
    ? {
        name: "transactionDetail",
        params: {
          transactionId: transaction.id,
        },
      }
    : transaction.donationId
      ? {
          name: "donationDetail",
          params: { donationId: transaction.donationId },
        }
      : {
          name: "transactionDetail",
          params: {
            transactionId: transaction.id,
          },
        }

const getStatusText = (
  transaction: ListTransactionsResponseItem
) => {
  return {
    successful: "",
    cancelled: "Cancelled",
    voided: "VOIDED",
    pending: "Pending",
    failed: "Failed",
  }[transaction.status]
}
</script>
